export default function animatePremiumQr() {
	const premiumQr = document.querySelector('.premium-qr');

	if (!premiumQr) return;

	const qrButtonArea = document.querySelector('.prem-offer__banker-qr__button');
	const qrButtonOpen = document.querySelector('.prem-offer__banker-qr__button-open');
	const qrButtonClose = document.querySelector('.prem-offer__banker-qr__button-close');
	const qrImg = document.querySelector('.prem-offer__banker-qr__img');

	function qrButtonsSwitch () {
		if (premiumQr.classList.contains('opened')) {
			qrButtonOpen.classList.remove('active');
			qrButtonClose.classList.add('active');
		} else {
			qrButtonClose.classList.remove('active');
			qrButtonOpen.classList.add('active');
		}
	}

	function toggleQr () {
		if (premiumQr.classList.contains('opened')) {
			premiumQr.classList.remove('opened');
			qrImg.classList.remove('opened');
		} else {
			premiumQr.classList.add('opened');
			qrImg.classList.add('opened');
		}
	}



	qrButtonsSwitch();


	qrButtonArea.addEventListener('click', () => {

		toggleQr();
		qrButtonsSwitch();


	});
}
